const sourcePage = document.getElementById('source').dataset.source;

const url = window.location.pathname.split('/')[1];

if (url === 'entreprises') {
  // remove source
  window.localStorage.removeItem('source');
  // set source
  var localStorageData = JSON.stringify({
    sourceName: sourcePage,
  });

  var source = window.localStorage.setItem('source', localStorageData);
  source = JSON.parse(window.localStorage.getItem('source'));
} else {
  // On vérifie si on a de la data dans le cache, s'il n'existe pas :
  if (window.localStorage.getItem('source') === null) {
    const now = new Date();
    var localStorageData = JSON.stringify({
      sourceName: sourcePage,
      expires: now.getTime() + 1000 * 60 * 60 * 24 * 1, //  + 1 day
      // expires: now.getTime() + 1000*10 //  + 10 sec
    });
    var source = window.localStorage.setItem('source', localStorageData);
    // S'il existe
  } else {
    const now = new Date();
    // La data est elle expirée?
    source = JSON.parse(window.localStorage.getItem('source'));
    if (now.getTime() > source.expires) {
      window.localStorage.removeItem('source');
      const now = new Date();
      var localStorageData = JSON.stringify({
        sourceName: sourcePage,
        expires: now.getTime() + 1000 * 60 * 60 * 24 * 1, //  + 1 day
        // expires: now.getTime() + 1000*10 //  + 10 sec
      });
      var source = window.localStorage.setItem('source', localStorageData);
    }
  }
  source = JSON.parse(window.localStorage.getItem('source'));
}

sourceFormulaire = document.getElementById('prospect_source');
sourceFormulaire.value = source.sourceName;
